// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
let DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
let Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
let ReactDatepicker = require("../../../uikit/atoms/Datepicker/ReactDatepicker.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let Options__LeaseLength = require("../../../reason/common/types/options/Options__LeaseLength.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardFormUtils = require("./PropertyWizardFormUtils.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardRelayKeyFactsRentalData_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsRentalData_draft_graphql.bs.js");
let PropertyWizardFormRelay__Validators__KeyFacts__PropertyType = require("./PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.bs.js");

let convertFragment = PropertyWizardRelayKeyFactsRentalData_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsRentalData_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsRentalData_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsRentalData_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsRentalData_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_leaseLengthValue_decode = PropertyWizardRelayKeyFactsRentalData_draft_graphql.Utils.leaseLengthValue_decode;

let DraftFragment_leaseLengthValue_fromString = PropertyWizardRelayKeyFactsRentalData_draft_graphql.Utils.leaseLengthValue_fromString;

let DraftFragment = {
  leaseLengthValue_decode: DraftFragment_leaseLengthValue_decode,
  leaseLengthValue_fromString: DraftFragment_leaseLengthValue_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__RentalData(props) {
  let stepHasBeenTouched = props.stepHasBeenTouched;
  let match = PropertyWizardFormRelay.Context.use();
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsRentalData_draft_graphql.node, convertFragment, props.draft);
  let draftProperty = draft.draftProperty;
  let leaseLengthOption = Stdlib_Option.map(draftProperty.leaseLength, Options__LeaseLength.make);
  let leaseLength = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.leaseLength = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draftProperty.leaseLength, PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.LeaseLength.useIsValid(draft.fragmentRefs));
  let availableFrom = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.availableFrom = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draftProperty.availableFrom, PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.AvailableFrom.useIsValid(draft.fragmentRefs));
  let match$1 = leaseLength.status;
  let tmp;
  let tmp$1 = match.mode;
  tmp = typeof tmp$1 !== "object" ? Primitive_option.some(CalendarDate.today(DateFnsTz.Timezone.make(draft.timeZone))) : undefined;
  return JsxRuntime.jsx(FormV5.FormSection.make, {
    children: JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
      children: [
        JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
          width: 12,
          widthMd: 4,
          children: [
            JsxRuntime.jsx(Form__Label.make, {
              labelText: "Length of Lease"
            }),
            JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
              getOptionLabel: Options__LeaseLength.getOptionLabel,
              getOptionValue: Options__LeaseLength.getOptionValue,
              onBlur: param => leaseLength.onBlur(),
              onChange: value => leaseLength.onChange(value !== undefined ? value.value : undefined),
              options: Options__LeaseLength.defaultOptions,
              value: leaseLengthOption,
              status: match$1 !== undefined ? (
                  match$1 === "ok" ? "Success" : "Failure"
                ) : "Neutral"
            }),
            JsxRuntime.jsx(Form__Components.FieldError.make, {
              valid: leaseLength.valid
            })
          ]
        }),
        JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
          width: 12,
          widthMd: 4,
          children: [
            JsxRuntime.jsx(Form__Label.make, {
              labelText: "Available From"
            }),
            JsxRuntime.jsx(ReactDatepicker.make, {
              onChange: value => availableFrom.onChange(value),
              selected: availableFrom.value,
              minDate: tmp,
              status: availableFrom.status
            }),
            JsxRuntime.jsx(Form__Components.FieldError.make, {
              valid: availableFrom.valid
            })
          ]
        })
      ]
    })
  });
}

let Components;

let FormSection;

let Grid;

let Cell;

let Validators;

let FormUtils;

let FormControl;

let make = PropertyWizardRelay__KeyFacts__RentalData;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Grid = Grid;
exports.Cell = Cell;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.FormControl = FormControl;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* FormV5 Not a pure module */
